import "./user-leadership-potential.css";

// Short Report: User vs User - Leadership Potential
// Unique classnames prefixed with tt-uvl- to avoid conflicts
const UserLeadershipPotentialReport = (comparisonResult) => {
  console.log(
    "UserLeadershipPotentialReport comparisonResult:",
    comparisonResult
  );
  const sr = comparisonResult?.comparisonData
    ?.userLeadershipPotentialShortReport ||
    comparisonResult?.userLeadershipPotentialShortReport || {
      userA: {
        name: "Alice",
        leadership_score: 50,
        readiness_category: "Not-ready",
        strengths: ["Adaptability"],
        weaknesses: ["Innovation"],
      },
      userB: {
        name: "Brian",
        leadership_score: 76,
        readiness_category: "Near-ready",
        strengths: ["Innovation"],
        weaknesses: ["Adaptability"],
      },
      overview:
        'Alice’s leadership potential score of 50% places her in the "Not-ready" category, with adaptability as a primary strength. Her weakness in innovation may limit strategic growth contributions. Brian’s score of 76% marks him as "Near-ready", supported by innovation strength, making him better suited for roles requiring creative problem solving despite lower adaptability. The 26% gap suggests Brian is closer to leadership readiness while Alice would benefit from focused innovation development.',
    };

  const personAName = sr?.userA?.name ?? "Person A";
  const personBName = sr?.userB?.name ?? "Person B";

  const aScore = Number(sr?.userA?.leadership_score ?? 0);
  const bScore = Number(sr?.userB?.leadership_score ?? 0);

  const aCategory = sr?.userA?.readiness_category ?? "";
  const bCategory = sr?.userB?.readiness_category ?? "";

  const aStrength = Array.isArray(sr?.userA?.strengths)
    ? sr.userA.strengths.length
    : "-";
  const bStrength = Array.isArray(sr?.userB?.strengths)
    ? sr.userB.strengths.length
    : "-";

  const aWeakness = Array.isArray(sr?.userA?.weaknesses)
    ? sr.userA.weaknesses.length
    : "-";
  const bWeakness = Array.isArray(sr?.userB?.weaknesses)
    ? sr.userB.weaknesses.length
    : "-";

  const overviewText = sr?.overview ?? "";

  return (
    <div className="tt-uvl-short-report-container">
      <div className="tt-uvl-report-header">
        <h3>Leadership Potential</h3>
        <p>Quick overview of leadership readiness between the selected users</p>
      </div>

      {/* Metric Cards */}
      <div className="tt-uvl-comparison-summary">
        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {Math.round(
                comparisonResult?.comparisonData?.leadershipShortReport
                  ?.userAData?.leadershipScore
              )}
              %
            </div>
            <div className="tt-uvl-summary-label">
              Leadership Score (
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.readinessCategory
              }
              )
            </div>
          </div>
        </div>

        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {Math.round(
                comparisonResult?.comparisonData?.leadershipShortReport
                  ?.userBData?.leadershipScore
              )}
              %
            </div>
            <div className="tt-uvl-summary-label">
              Leadership Score (
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.readinessCategory
              }
              )
            </div>
          </div>
        </div>

        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.strengths.length
              }
            </div>
            <div className="tt-uvl-summary-label">Strength(s)</div>
          </div>
        </div>

        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
              <path d="M4 22h16" />
              <path d="M10 14.66V17c0 .55.47.98.97 1.21C12.04 18.75 13 19.5 14 19.5s1.96-.75 3.03-1.29c.5-.23.97-.66.97-1.21v-2.34" />
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.strengths.length
              }
            </div>
            <div className="tt-uvl-summary-label">Strength(s)</div>
          </div>
        </div>

        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M11.562 3.266a.5.5 0 0 1 .876 0L14.5 8.5l5.5.5a.5.5 0 0 1 .281.85L16 14l1 5.5a.5.5 0 0 1-.766.44L12 17l-4.234 2.94a.5.5 0 0 1-.766-.44L8 14l-4.281-4.15a.5.5 0 0 1 .281-.85L9.5 8.5l2.062-5.234Z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userAData?.weaknesses.length
              }
            </div>
            <div className="tt-uvl-summary-label">Weak Skill(s)</div>
          </div>
        </div>

        <div className="tt-uvl-summary-card">
          <div className="tt-uvl-summary-icon" aria-hidden="true">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M11.562 3.266a.5.5 0 0 1 .876 0L14.5 8.5l5.5.5a.5.5 0 0 1 .281.85L16 14l1 5.5a.5.5 0 0 1-.766.44L12 17l-4.234 2.94a.5.5 0 0 1-.766-.44L8 14l-4.281-4.15a.5.5 0 0 1 .281-.85L9.5 8.5l2.062-5.234Z" />
            </svg>
          </div>
          <div className="tt-uvl-summary-content">
            <div className="tt-uvl-summary-label">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.name
              }
            </div>
            <div className="tt-uvl-summary-value">
              {
                comparisonResult?.comparisonData.leadershipShortReport
                  ?.userBData?.weaknesses.length
              }
            </div>
            <div className="tt-uvl-summary-label">Weak Skill(s)</div>
          </div>
        </div>
      </div>

      {/* Progress Bars */}
      <div className="tt-uvl-metrics-comparison">
        <h3>Leadership Score Comparison</h3>
        <div className="tt-uvl-metrics-chart">
          <div className="tt-uvl-metric-bar-container">
            <div className="tt-uvl-metric-info">
              <span className="tt-uvl-metric-name">
                {
                  comparisonResult?.comparisonData.leadershipShortReport
                    ?.userAData?.name
                }
              </span>
            </div>
            <div className="tt-uvl-metric-bar">
              <div
                className="tt-uvl-metric-fill"
                style={{
                  width: `${Math.max(
                    0,
                    Math.min(
                      100,
                      Math.round(
                        comparisonResult?.comparisonData.leadershipShortReport
                          ?.userAData?.leadershipScore
                      )
                    )
                  )}%`,
                }}
              ></div>
              <span className="tt-uvl-metric-value">
                {Math.max(
                  0,
                  Math.min(
                    100,
                    Math.round(
                      comparisonResult?.comparisonData.leadershipShortReport
                        ?.userAData?.leadershipScore
                    )
                  )
                )}
                %
              </span>
            </div>
          </div>

          <div className="tt-uvl-metric-bar-container">
            <div className="tt-uvl-metric-info">
              <span className="tt-uvl-metric-name">
                {
                  comparisonResult?.comparisonData.leadershipShortReport
                    ?.userBData?.name
                }
              </span>
            </div>
            <div className="tt-uvl-metric-bar">
              <div
                className="tt-uvl-metric-fill"
                style={{
                  width: `${Math.max(
                    0,
                    Math.min(
                      100,
                      Math.round(
                        comparisonResult?.comparisonData.leadershipShortReport
                          ?.userBData?.leadershipScore
                      )
                    )
                  )}%`,
                }}
              ></div>
              <span className="tt-uvl-metric-value">
                {Math.max(
                  0,
                  Math.min(
                    100,
                    Math.round(
                      comparisonResult?.comparisonData.leadershipShortReport
                        ?.userBData?.leadershipScore
                    )
                  )
                )}
                %
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Analysis Overview */}
      <div className="tt-uvl-insights-section">
        <h3>Analysis Overview</h3>
        <div className="tt-uvl-analysis-paragraph">
          <p>
            {comparisonResult?.comparisonData.leadershipShortReport?.overview}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserLeadershipPotentialReport;
